(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-cart-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MMCart) return;
  let tail = Promise.resolve();
  let pending = 0;
  let blocking = 0;
  let opener = null;
  let savedOverflow = '';
  let closeTimer;
  let recommendationRequest;
  let recommendationGeneration = 0;
  let recommendationKey = null;
  let cartPageDirty = false;
  let savedNote = null;
  let stateUncertain = false;
  const adding = new WeakSet();
  const dialog = () => document.getElementById('mm-cart');
  const content = () => document.getElementById('mm-cart-content');
  const text = key => dialog()?.dataset[key] || '';
  const root = () => window.Shopify?.routes?.root || '/';
  const message = (value, error = false) => {
    const status = document.getElementById('mm-cart-status');
    if (!status) return;
    status.textContent = value;
    status.dataset.error = String(error);
    document.getElementById('mm-cart-recovery').hidden = !error;
  };
  const busy = () => {
    const cart = dialog();
    if (!cart) return;
    cart.dataset.busy = String(blocking > 0);
    content()?.setAttribute('aria-busy', String(blocking > 0));
    cart.querySelectorAll('[data-mm-cart-mutation], [data-mm-cart-checkout]').forEach(button => {
      button.disabled = blocking > 0 || stateUncertain;
    });
  };
  const open = trigger => {
    const cart = dialog();
    if (!cart) return;
    clearTimeout(closeTimer);
    delete cart.dataset.closing;
    if (cart.open) return;
    opener = trigger || document.activeElement;
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    cart.showModal();
  };
  const close = () => {
    const cart = dialog();
    if (!cart?.open) return;
    clearTimeout(closeTimer);
    cart.dataset.closing = 'true';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) cart.close();
    else closeTimer = setTimeout(() => cart.close(), 250);
  };
  const request = async (path, body, controller = new AbortController()) => {
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root() + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin',
        headers: body instanceof FormData ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
        ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}), signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok) {
        const error = new Error(result.description || result.message || text('error'));
        error.rejected = response.status === 400 || response.status === 422;
        throw error;
      }
      return result;
    } finally { clearTimeout(timer); }
  };
  const recommendationFocus = () => {
    const active = document.activeElement;
    const card = active?.closest('#mm-cart-recommendations-slot [data-mm-related-product]');
    return card ? {
      product: card.dataset.mmRelatedProduct,
      selector: active.matches('.mm-cart__product-title') ? '.mm-cart__product-title' : active.tagName.toLowerCase()
    } : null;
  };
  const mountRecommendations = (source, focus = recommendationFocus()) => {
    const slot = document.getElementById('mm-cart-recommendations-slot');
    if (!slot || !source) return;
    slot.replaceChildren(...Array.from(source.childNodes).map(node => node.cloneNode(true)));
    const products = (content()?.dataset.products || '').split(',');
    slot.querySelectorAll('[data-mm-related-product]').forEach(card => {
      if (products.includes(card.dataset.mmRelatedProduct)) card.remove();
    });
    busy();
    if (focus && dialog()?.open) {
      const card = Array.from(slot.querySelectorAll('[data-mm-related-product]')).find(node => node.dataset.mmRelatedProduct === focus.product);
      const target = card?.querySelector(focus.selector);
      (target && !target.disabled ? target : dialog().querySelector('[data-mm-cart-close]'))?.focus({preventScroll:true});
    }
    document.dispatchEvent(new CustomEvent('mm:cart:rendered'));
  };
  const refreshRecommendations = async (force = false) => {
    const key = content()?.dataset.products || '';
    if (!force && key === recommendationKey) return;
    recommendationKey = key;
    recommendationRequest?.abort();
    recommendationRequest = new AbortController();
    const generation = ++recommendationGeneration;
    try {
      const result = await request('?sections=mm-cart-suggestions', undefined, recommendationRequest);
      if (generation !== recommendationGeneration) return;
      const source = new DOMParser().parseFromString(result['mm-cart-suggestions'] || '', 'text/html').querySelector('#mm-cart-suggestions');
      if (source) mountRecommendations(source);
      else recommendationKey = null;
    } catch {
      if (generation === recommendationGeneration) recommendationKey = null;
    }
  };
  const render = (html, refreshSuggestions = false) => {
    if (typeof html !== 'string') throw new Error('Missing cart section');
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('#mm-cart-content');
    const current = content();
    if (!next || !current) throw new Error('Missing cart content');
    stateUncertain = false;
    const active = document.activeElement;
    const focus = active?.dataset.mmCartFocus;
    const scrollTop = current.querySelector('.mm-cart__scroll')?.scrollTop || 0;
    const note = current.querySelector('[name="note"]');
    const noteValue = note?.value;
    const noteOpen = current.querySelector('#mm-cart-note-toggle')?.checked;
    const previousSuggestions = current.querySelector('#mm-cart-recommendations-slot');
    const focusedSuggestion = recommendationFocus();
    current.replaceWith(next);
    mountRecommendations(previousSuggestions, focusedSuggestion);
    const nextNote = next.querySelector('[name="note"]');
    savedNote = nextNote?.value || '';
    if (nextNote && noteValue !== undefined && note?.dataset.dirty === 'true') {
      nextNote.value = noteValue;
      nextNote.dataset.dirty = 'true';
    }
    if (noteOpen && next.querySelector('#mm-cart-note-toggle')) {
      next.querySelector('#mm-cart-note-toggle').checked = true;
      next.querySelector('#mm-cart-notes-content').hidden = false;
    }
    if (nextNote) {
      next.querySelector('#mm-cart-note-count').textContent = String(Math.max(0, 200 - nextNote.value.length));
      next.querySelector('#mm-cart-note-remaining').hidden = !nextNote.value;
    }
    const scroller = next.querySelector('.mm-cart__scroll');
    if (scroller) scroller.scrollTop = scrollTop;
    document.querySelectorAll('.cart_count, .cart-count').forEach(node => { node.textContent = next.dataset.count; });
    document.querySelectorAll('.cart-subtotal').forEach(node => { node.textContent = next.dataset.subtotal; });
    busy();
    if (focus && dialog()?.open) {
      const target = Array.from(next.querySelectorAll('[data-mm-cart-focus]')).find(node => node.dataset.mmCartFocus === focus);
      (target || dialog().querySelector('[data-mm-cart-close]'))?.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('mm:cart:rendered'));
    void refreshRecommendations(refreshSuggestions);
  };
  const refresh = async () => {
    const result = await request('?sections=mm-cart-content');
    render(result['mm-cart-content'], true);
  };
  const enqueue = (task, quiet = false) => {
    pending++;
    if (!quiet) blocking++;
    busy();
    const work = tail.catch(() => {}).then(task);
    tail = work.finally(() => { pending--; if (!quiet) blocking--; busy(); });
    tail.catch(() => {});
    return tail;
  };
  const mutate = async (path, data) => {
    if (stateUncertain) await refresh();
    if (data instanceof FormData) {
      data.set('sections', 'mm-cart-content');
      data.set('sections_url', root());
    } else data = { ...data, sections: 'mm-cart-content', sections_url: root() };
    let result;
    try { result = await request(path, data); }
    catch (error) {
      if (!error.rejected) {
        stateUncertain = true;
        cartPageDirty = true;
        try { await refresh(); } catch {}
      }
      throw error;
    }
    cartPageDirty = true;
    try { render(result.sections?.['mm-cart-content']); }
    catch { stateUncertain = true; await refresh(); }
    return result;
  };
  const fail = error => message(error.rejected ? error.message : text('uncertain'), true);
  const saveNote = async value => {
    if (value === savedNote) return;
    await request('cart/update.js', {note:value});
    savedNote = value;
  };
  const add = async (form, button) => {
    if (!dialog() || adding.has(form) || !form.reportValidity()) return;
    if (stateUncertain) { open(button); message(text('uncertain'), true); return; }
    const data = new FormData(form);
    if (!data.get('id') && !data.get('items[0][id]')) return;
    adding.add(form);
    const buttons = Array.from(form.elements).filter(node => node.matches('button[type="submit"], input[type="submit"]'));
    const originals = buttons.map(node => ({ node, html: node.innerHTML, value: node.value, disabled: node.disabled, busy: node.getAttribute('aria-busy') }));
    buttons.forEach(node => { node.disabled = true; node.setAttribute('aria-busy', 'true'); });
    const started = performance.now();
    const revealAfterAdd = !dialog().open;
    message(text('adding'));
    try {
      await enqueue(() => mutate('cart/add.js', data));
      dialog().dataset.lastAddMs = String(Math.round(performance.now() - started));
      if (revealAfterAdd) open(button);
      message(text('added'));
      try { window.MMRecoAnalytics?.added(form.closest('[data-mm-related-product]')); } catch {}
    } catch (error) { if (revealAfterAdd) open(button); fail(error); }
    finally {
      adding.delete(form);
      originals.forEach(({node, html, value, disabled, busy}) => {
        node.disabled = disabled; node.innerHTML = html; node.value = value;
        if (busy === null) node.removeAttribute('aria-busy'); else node.setAttribute('aria-busy', busy);
      });
      if (dialog()?.open && opener?.isConnected === false) opener = document.querySelector('a[href="/cart"]');
    }
  };
  const isProductForm = form => {
    if (!(form instanceof HTMLFormElement)) return false;
    const url = new URL(form.action, location.href);
    return url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
  };
  const consume = event => { event.preventDefault(); event.stopImmediatePropagation(); };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !dialog()) return;
    if (target.closest('[data-mm-cart-close]')) { consume(event); close(); return; }
    if (target === dialog()) {
      const bounds = dialog().getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      return;
    }
    const quantity = target.closest('[data-mm-cart-quantity]');
    if (quantity) {
      consume(event);
      if (blocking || stateUncertain) return;
      const row = quantity.closest('[data-mm-cart-key]');
      const next = quantity.dataset.mmCartQuantity === 'remove' ? 0 : Number(row.dataset.quantity) + Number(quantity.dataset.mmCartQuantity);
      if (!Number.isInteger(next) || next < 0) return;
      message(text('updating'));
      void enqueue(() => mutate('cart/change.js', {id: row.dataset.mmCartKey, quantity: next})).then(() => message(text('updated'))).catch(fail);
      return;
    }
    const button = target.closest('button, input[type="submit"]');
    if (button && isProductForm(button.form) && (button.type === 'submit' || button.classList.contains('add_to_cart'))) {
      consume(event);
      if (!button.disabled) void add(button.form, button);
      return;
    }
    const link = target.closest('a[href]');
    if (link && !link.matches('[data-mm-cart-recovery]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && /\/cart\/?$/.test(url.pathname) && !url.search && !link.hasAttribute('download')) {
        consume(event); open(link); message(text('loading'));
        void enqueue(refresh).then(() => message('')).catch(fail);
      }
    }
  }, true);
  document.addEventListener('keydown', event => {
    const cart = dialog();
    if (event.key !== 'Tab' || !cart?.open) return;
    const targets = Array.from(cart.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length);
    const first = targets[0], last = targets[targets.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!dialog()) return;
    if (isProductForm(event.target)) { consume(event); void add(event.target, event.submitter); return; }
    if (event.target.matches('[data-mm-cart-checkout-form]')) {
      consume(event);
      const button = event.target.querySelector('[data-mm-cart-checkout]');
      if (button.disabled) return;
      const value = dialog().querySelector('#mm-cart-note')?.value || '';
      button.disabled = true;
      void enqueue(() => saveNote(value)).then(() => {
        button.disabled = true;
        location.assign(root() + 'checkout');
      }).catch(error => { button.disabled = false; fail(error); });
    }
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('#mm-cart [name="note"]')) {
      event.target.dataset.dirty = 'true';
      const remaining = document.getElementById('mm-cart-note-count');
      if (remaining) remaining.textContent = String(Math.max(0, 200 - event.target.value.length));
      document.getElementById('mm-cart-note-remaining').hidden = !event.target.value;
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('#mm-cart-note-toggle')) {
      document.getElementById('mm-cart-notes-content').hidden = !event.target.checked;
      return;
    }
    if (event.target.matches('[data-mm-cart-variant]')) {
      const option = event.target.selectedOptions[0];
      const card = event.target.closest('[data-mm-related-product]');
      card.querySelector('[data-mm-variant-price]').textContent = option.dataset.price;
      const compare = card.querySelector('[data-mm-variant-compare]');
      compare.hidden = !option.dataset.compare;
      compare.textContent = option.dataset.compare;
      const img = card.querySelector('img');
      if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
      return;
    }
    if (!event.target.matches('#mm-cart [name="note"]')) return;
    consume(event);
    const note = event.target;
    const value = note.value;
    void enqueue(() => saveNote(value), true).then(() => {
      if (note.value === value) note.dataset.dirty = 'false';
    }).catch(fail);
  }, true);
  document.addEventListener('close', event => {
    if (event.target.id !== 'mm-cart') return;
    clearTimeout(closeTimer);
    delete event.target.dataset.closing;
    document.documentElement.style.overflow = savedOverflow;
    if (opener?.isConnected && !opener.disabled) opener.focus({preventScroll:true});
    if (cartPageDirty && /\/cart\/?$/.test(location.pathname)) location.reload();
  }, true);
  document.addEventListener('cancel', event => { if (event.target.id === 'mm-cart') { event.preventDefault(); close(); } }, true);
  window.addEventListener('pageshow', event => {
    // History can reload cached HTML without restoring the JavaScript snapshot.
    const historyReturn = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if ((event.persisted || historyReturn) && dialog()) { busy(); void enqueue(refresh).catch(fail); }
  });
  const initializeRecommendations = () => {
    savedNote = dialog()?.querySelector('#mm-cart-note')?.value || '';
    const source = document.getElementById('mm-cart-initial-recommendations')?.content.querySelector('#mm-cart-suggestions');
    if (source) recommendationKey = content()?.dataset.products || '';
    mountRecommendations(source);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRecommendations, {once:true});
  else initializeRecommendations();
  window.MMCart = { open, close, updateAttributes: attributes => enqueue(() => request('cart/update.js', {attributes}), true) };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-reco-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-mm-analytics]');
  if (!marker || window.MMRecoAnalytics) return;
  const preview = marker.dataset.mmAnalytics === 'preview';
  const endpoint = 'https://modest-mounts-recommendations-production.up.railway.app';
  const storageKey = preview ? 'mm_reco_preview_v1' : 'mm_reco_customer_v1';
  const withdrawalKey = 'mm_reco_withdraw_v1';
  const attribute = '__mm_reco';
  const labelAttribute = '__MM recommendations';
  const week = 7 * 86400000;
  let enabled = false;
  let running = false;
  let cartSignature = null;
  let cartWork = Promise.resolve();
  let epoch = 0;
  const permitted = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch { return null; }
  };
  const write = value => { try { localStorage.setItem(storageKey, JSON.stringify(value)); return true; } catch { return false; } };
  const random = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), n => n.toString(16).padStart(2, '0')).join('');
  const post = (path, body) => fetch(endpoint + path, { method: 'POST', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: AbortSignal.timeout(5000) });
  const updateCart = (tokens, receipt) => {
    cartWork = cartWork.catch(() => {}).then(async () => {
    const validReceipt = receipt && /^MM-[0-9a-z]{1,11}-[A-Za-z0-9_-]{22}$/.test(receipt.reference) && ['Cart drawer','Related Items','Cart drawer + Related Items'].includes(receipt.source);
    const attributes = validReceipt
      ? { [attribute]: '', [labelAttribute]: receipt.source + ' · ' + receipt.reference }
      : { [attribute]: tokens.length ? JSON.stringify(tokens) : '', [labelAttribute]: '' };
    const signature = JSON.stringify(attributes);
    if (signature === cartSignature) return;
    if (window.MMCart) {
      await window.MMCart.updateAttributes(attributes);
      cartSignature = signature;
      return;
    }
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attributes }), signal: AbortSignal.timeout(5000) });
    if (response.ok) cartSignature = signature;
    });
    return cartWork;
  };
  const withdrawals = () => {
    try { const value = localStorage.getItem(withdrawalKey); if (!value) return []; return /^[a-f0-9]{64}$/.test(value) ? [value] : JSON.parse(value); } catch { return []; }
  };
  const erase = async () => {
    for (const key of withdrawals()) {
      try {
        const response = await post('/analytics/withdraw', { visitorKey: key });
        if (response.ok) {
          const remaining = withdrawals().filter(k => k !== key);
          if (remaining.length) localStorage.setItem(withdrawalKey, JSON.stringify(remaining));
          else localStorage.removeItem(withdrawalKey);
        }
      } catch {}
    }
  };
  const flush = async () => {
    if (running || !enabled || !permitted()) return;
    running = true;
    const startedEpoch = epoch;
    try {
      for (let count = 0; count < 30 && enabled && permitted() && epoch === startedEpoch; count++) {
        const state = read();
        if (!state?.queue?.length) break;
        const item = state.queue[0];
        if (Date.now() - item.at > 3600000) { state.queue.shift(); write(state); continue; }
        const response = await post('/analytics/event', { ...item, visitorKey: state.visitorKey });
        if (epoch !== startedEpoch || !enabled || !permitted()) break;
        if (!response.ok) { if (response.status === 400) { state.queue.shift(); write(state); continue; } break; }
        const result = await response.json();
        const latest = read();
        if (!latest || latest.visitorKey !== state.visitorKey) break;
        latest.queue = latest.queue.filter(e => e.id !== item.id);
        latest.tokens = latest.tokens.filter(t => Date.now() - t.at < week && t.product !== (result.token ? item.product : ''));
        if (result.reference && result.source) latest.receipt = { reference: result.reference, source: result.source, at: Date.now() };
        if (result.token) latest.tokens.push({ product: item.product, at: item.at, value: result.token });
        latest.tokens = latest.tokens.slice(-12);
        write(latest);
      }
      if (enabled && permitted() && epoch === startedEpoch) {
        const state = read();
        if (state?.tokens?.length) await updateCart(state.tokens.filter(t => Date.now() - t.at < week).map(t => t.value), state.receipt && Date.now() - state.receipt.at < week ? state.receipt : null);
      }
    } catch {} finally { running = false; }
  };
  const track = (card, kind) => {
    if (!enabled || !permitted()) return;
    const owner = card?.closest('mm-related-items');
    if (!owner) return;
    const state = read();
    if (!state || state.queue.length >= 60) return;
    const placement = owner.dataset.placement;
    state.queue.push({ id: random(), at: Date.now(), kind, source: placement === 'cart' ? 'cart' : owner.dataset.sourceProduct, product: card.dataset.mmRelatedProduct, placement, consent: true, preview });
    if (write(state)) void flush();
  };
  const viewed = new WeakSet();
  const timers = new Map();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      clearTimeout(timers.get(entry.target));
      timers.delete(entry.target);
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !viewed.has(entry.target)) {
        timers.set(entry.target, setTimeout(() => {
          timers.delete(entry.target);
          if (!enabled || !permitted() || document.visibilityState !== 'visible') return;
          viewed.add(entry.target);
          track(entry.target, 'impression');
        }, 500));
      }
    }
  }, { threshold: [0, 0.5] });
  const watch = () => document.querySelectorAll('mm-related-items [data-mm-related-product]').forEach(card => { observer.unobserve(card); observer.observe(card); });
  const consentChanged = () => {
    const allowed = permitted();
    if (!allowed) {
      enabled = false;
      epoch++;
      const state = read();
      try {
        if (state?.visitorKey) localStorage.setItem(withdrawalKey, JSON.stringify([...new Set([...withdrawals(), state.visitorKey])]));
        localStorage.removeItem(storageKey);
      } catch {}
      for (const timer of timers.values()) clearTimeout(timer);
      timers.clear();
      if (state) void updateCart([]).catch(() => {});
      void erase();
      return;
    }
    let state = read();
    if (!state || !/^[a-f0-9]{64}$/.test(state.visitorKey) || !Array.isArray(state.queue) || !Array.isArray(state.tokens) || Date.now() - state.createdAt > 180 * 86400000) {
      state = { visitorKey: random(), createdAt: Date.now(), queue: [], tokens: [] };
      if (!write(state)) return;
    }
    enabled = true;
    watch();
    void flush();
  };
  window.MMRecoAnalytics = { added: card => track(card, 'add') };
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button');
    if (!target || !event.isTrusted) return;
    const card = target.closest('mm-related-items [data-mm-related-product]');
    if (card) track(card, 'click');
  }, true);
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('shopify:section:load', watch);
  document.addEventListener('mm:cart:rendered', watch);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') { watch(); void flush(); } });
  window.addEventListener('online', () => { void erase(); void flush(); });
  setInterval(() => { if (enabled) void flush(); }, 15000);
  void erase();
  if (window.Shopify?.customerPrivacy) consentChanged();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) consentChanged(); });
})();
  } catch(e) { console.error(e); }
})();

})();
